import type { ICellRendererParams } from 'ag-grid-community';

export function LabelCellRenderer({ valueFormatted, value }: ICellRendererParams<unknown, string>) {
  return <span>{valueFormatted ?? value}</span>;
}
